// extracted by mini-css-extract-plugin
export var QaIcon = "AdvisorFAQ-module--QaIcon--cYGQx";
export var advisorSection = "AdvisorFAQ-module--advisorSection--1pviK";
export var faqAnswer = "AdvisorFAQ-module--faqAnswer--Quok1";
export var faqItem = "AdvisorFAQ-module--faqItem--7QM2O";
export var faqList = "AdvisorFAQ-module--faqList--xp0MR";
export var faqQuestion = "AdvisorFAQ-module--faqQuestion--7rkoo";
export var faqTitle = "AdvisorFAQ-module--faqTitle--uOIqa";